import { useDispatch, useSelector } from "react-redux";
import React, { FC, useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";

import HistoriesAffiliates from "../../Screen/HistoriesAffiliates/HistoriesAffiliates";

import Helmet1 from "../../modules/Loading/Helmet1";

function Route() {
  return (
    <>
      <HistoriesAffiliates />
      {/* <Helmet1 />
      <Helmet>
        <meta
          name="viewport"
          content="width=device-width,initial-scale=1.0,minimum-scale=1.0"
        />
        <meta name="apple-mobile-web-app-capable" content="yes" />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://fonts.googleapis.com/css?family=Roboto:300,400,500,700|Roboto+Slab:400,700|Material+Icons"
        />
        <link
          rel="stylesheet"
          href="https://maxcdn.bootstrapcdn.com/font-awesome/latest/css/font-awesome.min.css"
        />
        <link
          id="HistoriesAffiliates"
          rel="stylesheet"
          href="/dist/css/admin.css"
          onload="$('.Helmet1').hide()"
        />
        <title>SC WORLD EXCHANGE</title>
      </Helmet> */}
      {/* {width > 992 ? ( */} {/* ) : ( */}
      {/* <div id="style-sm" className="overflow-hidden"> */} {/* <Router /> */}
      {/* </div> */} {/* )} */}
      {/* <div className="d-none d-lg-block">
                    <About />
                  </div>
                  <div className="d-lg-none overflow-hidden"><AboutSm /></div> */}
    </>
  );
}

export default Route;
